"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicantsProfile = ApplicantsProfile;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_styled_1 = require("styled-breakpoints/react-styled");
const styled_breakpoints_1 = require("styled-breakpoints");
const react_intl_1 = require("react-intl");
const react_router_dom_1 = require("react-router-dom");
const uuid = __importStar(require("uuid"));
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("@src/api"));
const get_cdn_image_url_1 = require("@shared/get-cdn-image-url");
const profile_context_1 = require("@src/components/pages/profile/profile-context");
const app_context_1 = require("@src/context/app-context");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const DriverLicenceSelect_1 = require("@src/components/modules/global/DriverLicenceSelect");
const ApplicantProfileJobExperience_1 = require("./ApplicantProfileJobExperience");
const ApplicantProfileSchoolExperience_1 = require("./ApplicantProfileSchoolExperience");
const ApplicantProfileLanguage_1 = require("./ApplicantProfileLanguage");
const ApplicantProfileAbout_1 = require("./ApplicantProfileAbout");
const ApplicantProfileCertificateExperience_1 = require("./ApplicantProfileCertificateExperience");
const transformApiData_1 = require("./transformApiData");
const ApplicantProfileSkill_1 = require("./ApplicantProfileSkill");
function getImageThumb(pictureUrl) {
    return (0, get_cdn_image_url_1.getCdnImageUrl)({
        file: `web/account/${pictureUrl}`,
        transformation: 'w_150,h_150,c_limit',
    });
}
const showSuccessSaveNotification = intl => {
    antd_1.notification.success({
        message: intl.formatMessage({
            id: 'profile.resume.successfuly_saved',
        }),
        placement: 'bottomRight',
    });
};
const showFailedToSaveNotification = intl => {
    antd_1.notification.error({
        message: intl.formatMessage({
            id: 'profile.resume.error',
        }),
        description: intl.formatMessage({
            id: 'profile.resume.something_went_wrong',
        }),
        placement: 'bottomRight',
    });
};
const showMissingRequiredFieldNotification = intl => {
    antd_1.notification.error({
        message: intl.formatMessage({
            id: 'profile.resume.error',
        }),
        description: intl.formatMessage({
            id: 'profile.resume.missing_required_fields',
        }),
        placement: 'bottomRight',
    });
};
function ApplicantsProfile() {
    const [fileList, setFileList] = react_1.default.useState([]);
    const [hasPhotoAlready, setHasPhotoAlready] = react_1.default.useState(false);
    const [accountSkills, setAccountSkills] = react_1.default.useState([]);
    const [loading, setLoading] = react_1.default.useState(false);
    const isXsLayout = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.only)('xs'));
    const isMdLayout = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.only)('md'));
    const isSmallLayout = isXsLayout || isMdLayout;
    const ProfileContext = (0, profile_context_1.useProfileContextValue)();
    const AppContext = (0, app_context_1.useAppContextProvider)();
    const [wasProfileSavedBefore, setWasProfileSavedBefore] = react_1.default.useState(false);
    const [isInitialized, setIsInitialized] = react_1.default.useState(false);
    const [form] = antd_1.Form.useForm();
    const intl = (0, react_intl_1.useIntl)();
    const history = (0, react_router_dom_1.useHistory)();
    const SSRFetchClient = (0, useSSRFetch_1.useSSRFetchClient)();
    const submitForm = async (formData) => {
        var _a;
        try {
            setLoading(true);
            const profileFormData = {
                ...formData,
                driverLicence: ((_a = formData.driverLicence) === null || _a === void 0 ? void 0 : _a.length) ? formData.driverLicence.join() : null,
                accountSkills,
            };
            await Api.Profile.setMyProfile(profileFormData, AppContext.value.language);
            if ((fileList === null || fileList === void 0 ? void 0 : fileList.length) === 1 && fileList[0].originFileObj) {
                await Api.Profile.uploadProfileImage(fileList[0].originFileObj);
            }
            else if (fileList.length === 0 && hasPhotoAlready) {
                await Api.Profile.removeProfileImage();
                SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
            }
            showSuccessSaveNotification(intl);
            // ProfileContext.value.updateProfileEmptyFields()
            ProfileContext.updateProfileEmptyFields();
            // @ts-ignore
            history.pushLocalized('/ucet/profil');
        }
        catch (err) {
            showFailedToSaveNotification(intl);
            // eslint-disable-next-line no-console
            console.error(err);
        }
        finally {
            setLoading(false);
        }
    };
    const init = async () => {
        try {
            const profileResume = await Api.Profile.getMyProfile();
            if (profileResume) {
                setWasProfileSavedBefore(Boolean(profileResume.uuid));
                const profilePicture = profileResume.profile_picture_url;
                const transformedData = (0, transformApiData_1.transformFromApiFormat)(profileResume);
                form.setFieldsValue(transformedData);
                if (transformedData.profileSkills) {
                    setAccountSkills(transformedData.profileSkills);
                }
                if (profilePicture) {
                    setHasPhotoAlready(true);
                    const profilePictureThumb = getImageThumb(profilePicture);
                    setFileList([{ thumbUrl: profilePictureThumb, uid: uuid.v4() }]);
                }
            }
        }
        catch (err) {
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
            // eslint-disable-next-line no-console
            console.error(err);
        }
        finally {
            setIsInitialized(true);
        }
    };
    react_1.default.useEffect(() => {
        init();
    }, []);
    const onFinishFailed = ({ errorFields }) => {
        showMissingRequiredFieldNotification(intl);
        form.scrollToField(errorFields[0].name, {});
    };
    if (!isInitialized) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "panel", children: (0, jsx_runtime_1.jsxs)(antd_1.Form, { form: form, name: "applicantProfile", autoComplete: "off", layout: "vertical", onFinish: submitForm, onFinishFailed: onFinishFailed, children: [(0, jsx_runtime_1.jsx)(ApplicantProfileAbout_1.ApplicantProfileAbout, { intl: intl, form: form, fileList: fileList, setFileList: setFileList }), (0, jsx_runtime_1.jsx)("h2", { className: "m-b-l m-t-s", children: (0, jsx_runtime_1.jsx)("b", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.my_skills" }) }) }), (0, jsx_runtime_1.jsx)(ApplicantProfileSkill_1.ApplicantProfileSkill, { accountSkills: accountSkills, setAccountSkills: setAccountSkills, form: form }), (0, jsx_runtime_1.jsx)("h2", { className: "m-b-l m-t-s", children: (0, jsx_runtime_1.jsx)("b", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.my_education" }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.List, { name: "schoolExperience", children: (schoolFields, { add, remove }) => ((0, jsx_runtime_1.jsx)(ApplicantProfileSchoolExperience_1.ApplicantProfileSchoolExperience, { fields: schoolFields, add: add, remove: remove, intl: intl, isSmallLayout: isSmallLayout, wasProfileSavedBefore: wasProfileSavedBefore })) }), (0, jsx_runtime_1.jsx)("h2", { className: "m-b-l m-t-s", children: (0, jsx_runtime_1.jsx)("b", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.job" }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.List, { name: "jobExperience", children: (jobFields, { add, remove }) => ((0, jsx_runtime_1.jsx)(ApplicantProfileJobExperience_1.ApplicantProfileJobExperience, { fields: jobFields, add: add, remove: remove, intl: intl, isSmallLayout: isSmallLayout, wasProfileSavedBefore: wasProfileSavedBefore, form: form })) }), (0, jsx_runtime_1.jsx)("h2", { className: "m-b-l m-t-s", children: (0, jsx_runtime_1.jsx)("b", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.certificate" }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.List, { name: "certificates", children: (certificateFields, { add, remove }) => ((0, jsx_runtime_1.jsx)(ApplicantProfileCertificateExperience_1.ApplicantProfileCertificateExperience, { fields: certificateFields, add: add, remove: remove, getFieldValue: form.getFieldValue, getFieldsValue: form.getFieldsValue, intl: intl, isSmallLayout: isSmallLayout })) }), (0, jsx_runtime_1.jsx)("h2", { className: "m-b-l m-t-s", children: (0, jsx_runtime_1.jsx)("b", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.language_skills" }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.List, { name: "profileLanguage", children: (profileLanguageFields, { add, remove }) => ((0, jsx_runtime_1.jsx)(ApplicantProfileLanguage_1.ApplicantProfileLanguage, { fields: profileLanguageFields, add: add, remove: remove, intl: intl, wasProfileSavedBefore: wasProfileSavedBefore, form: form })) }), (0, jsx_runtime_1.jsx)("h2", { className: "m-b-l m-t-s", children: (0, jsx_runtime_1.jsx)("b", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.resume.other" }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { className: "m-b-xl", label: intl.formatMessage({
                        id: 'profile.resume.driver_licence',
                    }), name: "driverLicence", children: (0, jsx_runtime_1.jsx)(DriverLicenceSelect_1.DriverLicenceSelect, { placeholder: "AM, A, B1, T", mode: "multiple", allowClear: true }) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { children: (0, jsx_runtime_1.jsx)("div", { className: "flex-center", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { type: "primary", htmlType: "submit", loading: loading, children: (0, jsx_runtime_1.jsx)("span", { className: loading ? 'm-l-s' : '', children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "profile.settings.save_changes" }) }) }) }) })] }) }));
}
